export default "__VITE_ASSET__3a8a6fcf__"